import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Flex } from '../../components/Flex';
import { Text } from '../../components/Text';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useShouldDirectUserToSub } from '../../hooks/useShouldDirectUserToSub';
import { useShouldSetTheme } from '../../hooks/useShouldSetTheme';
import { useAppSelector } from '../../redux/store';
import { userSliceSelectors } from '../../redux/user/user.selector';
import { Rounded } from '../../theme/Rounded';
import { Spacing } from '../../theme/Spacing';
import { DashboardAtiraLinkWidget } from './components/DashboardAtiraLinkWidget';
import { DashboardHeader } from './components/DashboardHeader';
import { DashboardIndexWidget } from './components/DashboardIndexWidget';
import { DashboardQRWidget } from './components/DashboardQRWidget';
import { DashboardURLWidget } from './components/DashboardURLWidget';

const Container = styled(Flex)`
  margin: ${Spacing.s} ${Spacing.m};
  gap: ${Spacing.m};
  flex-direction: column;
  flex: 1 1 0%;
`;

const SectionWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.m};
  width: 100%;
`;

const Section = styled(Flex)`
  background-color: ${({ theme }) => theme.light};
  border-radius: ${Rounded.lg};
  padding: ${Spacing.m};
  flex-direction: column;
  gap: ${Spacing.m};
`;

export const Dashboard: React.FC = () => {
  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  const { t } = useTranslation();
  useDocumentTitle(
    `${t('app.name').toUpperCase()} - ${t('side_menu.dashboard')}`,
  );
  useShouldDirectUserToSub(user);
  useShouldSetTheme();

  return (
    <Container>
      <DashboardHeader />

      <SectionWrapper>
        <DashboardAtiraLinkWidget />
        <DashboardURLWidget />
        <DashboardQRWidget />
        <DashboardIndexWidget />

        {process.env.APP_ENV === 'staging' ? (
          <Section>
            <Text fontSize="l" align="center" color={'danger'}>
              /\/\ STAGING /\/\
            </Text>
          </Section>
        ) : null}
      </SectionWrapper>
    </Container>
  );
};
